import request from '@/utils/request'

//公司主体档案
export function getBasSubjectList(data) {
  return request({
    url: `/wms-web/area/basSubject/list`,
    method: 'post',
    data: data
  })
}

//公司主体档案
export function getBasSubjectList2(data) {
  return request({
    url: `/wms-web/basSubject/list`,
    method: 'post',
    data: data
  })
}